// External
import React from "react";
import moment from "moment";
import _ from "lodash";

// Design system
import { CopyOutlined } from "@toddle-edu/ds-icons";
import { IconButton } from "@toddle-edu/ds-web";

// Utils
import { copyToClipboard } from "Utils/CopyToClipboard";

// Constants
import { CURRICULUM_TYPE_PYP } from "Constants/stringConstants";

// Helper function to get remarks logs table configuration
export const getRemarkLogsColumnList = ({ curriculumProgramType }) => {
  return [
    curriculumProgramType == CURRICULUM_TYPE_PYP
      ? {
          id: "course",
          label: "Course",
          hideTooltip: true,
          visible: true,
          alignment: "left",
          type: "TEXTCOLUMN",
          style: { width: "10%" },
        }
      : {
          id: "grade",
          label: "Grade",
          hideTooltip: true,
          visible: true,
          alignment: "left",
          type: "TEXTCOLUMN",
          style: { width: "10%" },
        },
    {
      id: "student",
      label: "Student",
      hideTooltip: true,
      visible: true,
      alignment: "left",
      type: "TEXTCOLUMN",
      style: { width: "10%" },
    },
    {
      id: "teacher",
      label: "Teacher",
      hideTooltip: true,
      visible: true,
      alignment: "left",
      type: "TEXTCOLUMN",
      style: { width: "10%" },
    },
    {
      id: "subject",
      label: "Subject",
      hideTooltip: true,
      visible: true,
      alignment: "left",
      type: "TEXTCOLUMN",
      style: { width: "10%" },
    },
    {
      id: "commentLabel",
      label: "Comment label",
      hideTooltip: true,
      visible: true,
      alignment: "left",
      type: "TEXTCOLUMN",
      style: { width: "10%" },
    },
    {
      id: "oldComment",
      label: "Previous comment",
      hideTooltip: true,
      visible: true,
      alignment: "left",
      type: "CUSTOM",
      style: { width: "20%" },
    },
    {
      id: "newComment",
      label: "Current comment",
      hideTooltip: true,
      visible: true,
      alignment: "left",
      type: "CUSTOM",
      style: { width: "20%" },
    },
    {
      id: "updatedAt",
      label: "Updated at",
      hideTooltip: true,
      visible: true,
      alignment: "left",
      type: "TEXTCOLUMN",
      style: { width: "10%" },
    },
  ];
};

export const getRemarkLogsFeedData = ({ data, curriculumProgramType }) => {
  if (!data || !_.isArray(data)) {
    return [];
  }

  return _.map(data, (item, index) => ({
    id: index,
    ...(curriculumProgramType == CURRICULUM_TYPE_PYP
      ? { course: _.get(item, "courseName", "-") }
      : { grade: _.get(item, "gradeName", "-") }),
    student: _.get(item, "studentName", "-"),
    teacher: _.get(item, "teacherName", "-"),
    subject: _.get(item, "subjectName", "-"),
    commentLabel: _.get(item, "commentLabel", "-"),
    oldComment: _.get(item, "oldComment", "-"),
    newComment: _.get(item, "newComment", "-"),
    updatedAt: _.get(item, "updatedAt")
      ? moment(_.get(item, "updatedAt")).format("DD MMM YYYY hh:mm A")
      : "-",
  }));
};

export const getRemarkLogsQueryInput = ({ data }) => {
  const entityType = _.get(data, "entityType");
  const curriculumProgramId = _.get(data, "curriculumProgramId");

  switch (entityType) {
    case "COURSE_PROGRESS_REPORT_TASK":
      return {
        entityIds: [_.get(data, "courseProgressReportTaskId")],
        entityType,
        curriculumProgramId,
      };
    case "STUDENT_PROGRESS_REPORT":
      return {
        entityIds: [_.get(data, "studentProgressReportId")],
        entityType,
        curriculumProgramId,
        ...(!_.isEmpty(_.get(data, "filters"))
          ? { filters: data.filters }
          : {}),
      };
    case "PROGRESS_REPORT_TASK_GROUP":
    default:
      return {
        entityIds: [_.get(data, "progressReportTaskGroupId")],
        entityType,
        curriculumProgramId,
      };
  }
};

export const getCustomComponent = ({ column, columnData, setToastMsg }) => {
  switch (column.id) {
    case "oldComment":
    case "newComment":
      if (columnData && !_.isEmpty(_.trim(columnData))) {
        const handleCopyComment = () => {
          copyToClipboard(columnData, () => {
            setToastMsg({
              msg: "Comment copied to clipboard",
              type: "success",
            });
          });
        };

        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <div
              style={{
                maxHeight: "300px",
                overflow: "auto",
                whiteSpace: "normal",
                wordWrap: "break-word",
                overflowWrap: "break-word",
                wordBreak: "break-word",
                padding: "8px",
                flex: 1,
              }}
              dangerouslySetInnerHTML={{ __html: columnData }}
            />

            <IconButton
              size={"small"}
              icon={<CopyOutlined variant="subtle" />}
              variant="neutral"
              type="outlined"
              onClick={handleCopyComment}
              title="Copy Comment"
            />
          </div>
        );
      }
      return "";

    default:
      return columnData || "";
  }
};
